import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import ComeBackIndicate from "./components/comback/ComeBackIndicate";



ReactDOM.render(
  <>
    <ComeBackIndicate />
    <App />
  </>,
  document.getElementById("root")
);

